import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person taps "Next" on Desktop search modal
 *
 * &nbsp;
 */
export class SearchInterstitialDesktopNext extends AnalyticsEvent {
  eventName = 'search-interstitial-next-cta-click';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.recommendations.browse_search;
}
